import { c as _c } from "react/compiler-runtime";
import { UserDisplay } from "@components/common/user-display";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { Dialog, Text, useToast } from "@flat-ui";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { convertToTeamMemberTypes } from "@store/members/members-slice-utils";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector } from "@store/teams/teams-selector";
import { deleteTeam } from "@store/teams/teams-slice-thunk";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Confirmation dialog for removing a team from the workspace.
 * Handles tracking, dispatching the delete, and showing a success toast.
 */
export function RemoveTeamDialog(t0) {
  const $ = _c(18);
  const {
    team,
    onClose
  } = t0;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    openToast
  } = useToast();
  const {
    isRemovingTeam
  } = useAppSelector(fetchingTeamsFlagsSelector);
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== onClose || $[3] !== openToast || $[4] !== team.id || $[5] !== team.memberCount || $[6] !== trackEvent) {
    t1 = async function removeTeam() {
      trackEvent({
        name: TeamEvents.deleteTeam,
        props: {
          numberOfMembers: team.memberCount
        }
      });
      try {
        await dispatch(deleteTeam({
          companyId,
          teamId: team.id
        })).unwrap();
        openToast({
          title: `${capitalizeFirstLetter(TEAM_DISPLAY_NAME)} deleted successfully`
        });
        onClose();
      } catch {}
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = onClose;
    $[3] = openToast;
    $[4] = team.id;
    $[5] = team.memberCount;
    $[6] = trackEvent;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const removeTeam = t1;
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text variant="bodyM" sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}>This action will only remove the selected {TEAM_DISPLAY_NAME}. All the members of the {TEAM_DISPLAY_NAME} will remain in the workspace.</Text>;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== team) {
    t3 = convertToTeamMemberTypes(team);
    $[9] = team;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <UserDisplay member={t3} />;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isRemovingTeam || $[14] !== onClose || $[15] !== removeTeam || $[16] !== t4) {
    t5 = <Dialog title={`Remove ${TEAM_DISPLAY_NAME}?`} confirmText="Remove" open={true} onConfirm={removeTeam} onCancel={onClose} showSpinner={isRemovingTeam}>{t2}{t4}</Dialog>;
    $[13] = isRemovingTeam;
    $[14] = onClose;
    $[15] = removeTeam;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}